<template>
  <div class = "ibox float-e-margins">
    <div class = "ibox-title">
      <h5>รายการเดิมพัน</h5>
    </div>
    <div class = "ibox-content">
      <div class="form-inline" style="margin-bottom:15px;">
        <div class="form-group">
          <select class = "form-control " v-model = "options.weekly_id" @change = "filterWeekly">
            <option v-for = "(week, index) in options.weekly" :value = "index" :key="index">{{ week }}</option>
          </select>
        </div>
        <div class="form-group">
          <select class = "form-control " v-model = "options.game_id" @change = "filterGames">
            <option value = "">กรองตามเกมส์</option>
            <option v-for="(game, index) in options.games" :value="game.id" :key="index">{{ game.title }}<option>
          </select>
          
        </div>
      </div>
      <div class="table-responsive table-scrollable space-loader" v-bind:class="{ loading: loading }">
        <vuetable
          ref = "vuetable"
          :api-url = "apiUrl"
          :append-params = "appendParams"
          :http-options = "httpOptions"
          @vuetable:loading="onLoading"
          @vuetable:loaded="onLoaded"
          :fields = "fields"
          :css = "css.table">
          <template slot = "sum_commission_amount" slot-scope = "props">
            <span>
              {{ props.rowData.sum_credit_commission_amount + props.rowData.sum_rolling_commission_amount | number}}
            </span>
          </template>
          <template slot = "totalbet" slot-scope = "props">
            <span>
              {{ props.rowData.total_bet_credit + props.rowData.total_bet_rolling | number}}
            </span>
          </template>
          <template slot = "sum_result_player_bet" slot-scope = "props">
            <span class = "text-positive" v-if = "props.rowData.sum_result_player_bet*(-1)>=0">
              {{ props.rowData.sum_result_player_bet * (-1) | number }}
            </span>
            <span class = "text-negative" v-else-if = "props.rowData.sum_result_player_bet*(-1)<0">
              {{ props.rowData.sum_result_player_bet * (-1) | number }}
            </span>
          </template>
        </vuetable>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import Vuetable from 'vuetable-2/src/components/Vuetable'
  import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'

  export default {
    name: 'member-bet-games',
    components: {
      Vuetable
    },
    props: {
      userId: {
        type: Number
      }
    },
    computed: {
      apiUrl () {
        return `/api/members/${this.userId}/stakes`
      }
    },
    data: function () {
      return {
        loading:false,
        options: {
          weekly: {},
          weekly_id: null,
          game_id: ''
        },
        css: {
          table: {
            tableClass: 'table table-striped table-bordered'
          }
        },
        fields: [
          {
            name: 'daily',
            title: 'วันที่',
          },
          {
            name: 'total_round',
            title: '#รายการ'
          },
          {
            name: '__slot:totalbet',
            title: 'เดิมพันทั้งหมด',
            titleClass: 'text-right',
            dataClass: 'text-right'
          },
          // {
          //   name: '__slot:sum_commission_amount',
          //   title: 'ค่าต๋ง',
          //   titleClass: 'text-right',
          //   dataClass: 'text-right text-info'
          // },
          {
            name: '__slot:sum_result_player_bet',
            title: 'รวม ได้/เสีย',
            titleClass: 'text-right',
            dataClass: 'text-right',
          }

        ],
        appendParams: {
          status: 'success'
        },
        moreParams: {
          range: {
            begin: '',
            ended: ''
          }
        },
        httpOptions: {
          headers: {
            'X-CSRF-TOKEN': window.App.csrfToken,
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + window.App.jwtToken
          }
        }
      }
    },
    mounted () {
    },
    methods: {
      resetToToday () {
        this.moreParams.range.begin = ''
        this.moreParams.range.ended = ''
      },
      transform (data) {
        this.options = data.options
        var tranform = data
        tranform.data.push({
          daily: 'สรุปยอดรวม',
          total_round: _.sumBy(data.data, 'total_round'),
          total_bet_credit: parseFloat(_.sumBy(data.data, 'total_bet_credit')),
          total_bet_rolling: parseFloat(_.sumBy(data.data, 'total_bet_rolling')),
          sum_credit_commission_amount: _.sumBy(data.data, 'sum_credit_commission_amount'),
          // sum_rolling_commission_amount: _.sumBy(data.data, 'sum_rolling_commission_amount'),
          sum_result_player_bet: _.sumBy(data.data, 'sum_result_player_bet'),
        })

        return tranform
      },
      filterWeekly () {
        this.moreParams.weekly_id = this.options.weekly_id
        this.appendParams = _.assign(this.appendParams, this.moreParams)
        Vue.nextTick(() => this.$refs.vuetable.refresh())
      },
      filterGames () {
        this.moreParams.game_id = this.options.game_id
        this.appendParams = _.assign(this.appendParams, this.moreParams)
        Vue.nextTick(() => this.$refs.vuetable.refresh())
      },
      onLoading() {
        this.loading=true
      },
      onLoaded() {
        this.loading=false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/MemberBetGames/MemberBetGames.vue